/** @format */

import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { AnalyticsService, CookieService, Logger, WINDOW } from '@shared/data-access/services';

/** @dynamic */
@Injectable({
	providedIn: 'root'
})
export class CategoryAnalyticsService extends AnalyticsService {
	constructor(
		@Inject(DOCUMENT) protected document: HTMLDocument,
		@Inject(WINDOW) protected window: Window,
		protected cookieService: CookieService,
		protected logger: Logger
	) {
		super(document, window, cookieService, logger);
	}

	/**
	 * @ngdoc method
	 * @name dcsg.app.services.service:AnalyticsService#setDYMTerm
	 * @methodOf dcsg.app.services.service:AnalyticsService
	 *
	 * @param CategoryID - The Category ID
	 *
	 * @description
	 * Pull the pages category id
	 */
	setCategoryID(CategoryID: string): void {
		this.window.siteData.CategoryID = CategoryID;
	}

	/**
	 * @ngdoc method
	 * @name dcsg.app.services.service:AnalyticsService#setDYMTerm
	 * @methodOf dcsg.app.services.service:AnalyticsService
	 *
	 * @param CategoryName - The Category Name
	 *
	 * @description
	 * Pulls the pages category name
	 */
	setCategoryName(CategoryName: string): void {
		this.window.siteData.CategoryName = CategoryName;
	}

	/**
	 * @ngdoc method
	 * @name dcsg.app.services.service:AnalyticsService#setDYMTerm
	 * @methodOf dcsg.app.services.service:AnalyticsService
	 *
	 * @param CategoryName - The Category Name
	 *
	 * @description
	 * Pulls the pages category name
	 */
	setCategoryParentsDetails(CategoryParentDetails: any): void {
		this.window.siteData.MCSalesCatalogDetails = CategoryParentDetails;
	}
}
